<template>
	
<component :is="navbarFixed ? 'a-affix' : 'div'" :offset-top="top">

    <a-layout-header style="margin-top: 0px !important;">

        <a-row type="flex">
            
            <!-- <div class="header-col header-brand">
                <img src="/images/logos/logo.svg" class="header-logo" style="height: 40px;width: 40px;"/>
			    <h6 style="color: black !important;">Ruaral Development & <br> Co-operatives Division</h6>
		    </div> -->
            
            <a-col :span="24" :md="1" style="display: flex; align-items:center; justify-content: center;">
                <img src="/images/logos/logo.svg" class="header-logo" style="height: 40px;width: 40px;" />
            </a-col>
            <a-col :span="24" :md="5" style="display: flex; align-items:center; justify-content: start;">
                <h6 style="font-size: 12px; margin-left: 10px;  color: white !important;">{{$t('site-title-l1') }}<br> {{ $t('site-title-l2') }}</h6>
            </a-col>
                <!-- <div class="display: flex; flex-direction: row; align-items:center; justify-content: center">
                    
			        
                </div> -->
            <!-- </a-col> -->

            <a-col :span="24" :md="12" style="display: flex; justify-content: center;">
                <div class="ant-page-header-heading" style="display: flex; align-items: center; justify-content: center;">
                    <span class="ant-page-header-heading-title" style="font-size: 26px !important; color:#fff">{{ this.$route.meta.displayTitle ? $t(this.$route.meta.displayTitle) : '' }}</span>
                </div>
            </a-col>
            
            <a-col :span="24" :md="6" class="header-control">
                <logged-in-dropdown />
                <locale-dropdown class="locale_dropdown" style="margin-right: 10px;"/>
            </a-col>
        </a-row>
    </a-layout-header>
</component>

</template>

<script>
import { navigationMixin } from "../../mixins/navigation-mixin.js";
import LoggedInDropdown from './LoggedInDropdown.vue';
import LocaleDropdown from '../../locales/LocaleDropdown.vue';

export default {
    mixins: [ navigationMixin ],
    components: {
        LoggedInDropdown,
        LocaleDropdown
    },
    props: {
        // Header fixed status.
        navbarFixed: {
            type: Boolean,
            default: false,
        },

        // Sidebar collapsed status.
        sidebarCollapsed: {
            type: Boolean,
            default: false,
        },

        
    },
    data() {
        return {
            // Fixed header/sidebar-footer ( Affix component ) top offset.
            top: -0.01,

            // Search input loading status.
            searchLoading: false,

            // The wrapper element to attach dropdowns to.
            wrapper: document.body,
            userData: "",
        }
    },
    computed: {
        

    },
    methods: {
        resizeEventHandler(){
            this.top = -0.01; //this.top ? 0 : -0.01 ;
            // To refresh the header if the window size changes.
            // Reason for the negative value is that it doesn't activate the affix unless
            // scroller is anywhere but the top of the page.
        }

    },

    mounted() {
        // Set the wrapper to the proper element, layout wrapper.
        this.wrapper = document.getElementsByClassName('layout-dashboard')[0] ;
        this.userData = (JSON.parse(localStorage.getItem("currentUser")));
    },
    created() {
        // Registering window resize event listener to fix affix elements size
        // error while resizing.
        window.addEventListener("resize", this.resizeEventHandler);
    },
    destroyed() {
        // Removing window resize event listener.
        window.removeEventListener("resize", this.resizeEventHandler);
    },
}

</script>

<style lang="scss">
// .header-notifications-list > ul {
// 	position: relative;
// 	right: 25px;
// }
.header-notifications-list .dropdown_item {
/* //   font-family: "Circular Std", sans-serif; */
	list-style: none;
	font-feature-settings: "pnum" on, "lnum" on;
  	font-style: normal;
  	line-height: 140%;
  	font-size: 1.125rem;
  	font-weight: 600;
  	color: #181F29;
  	white-space: nowrap;
  	margin: 10px 60px 5px 5px;
}

.header-notifications-list .dropdown_item:hover{
    background-color: #0069ff;
    color: #fff !important;
    width: 90%;
    padding: 5px;
    // padding-left: 10px;
    border-radius: 5px;
}
</style>
